import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, Typography } from '@mui/material';
import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react';
import { useTranslation } from 'react-i18next';

import { COLOR } from '@/theme/colors';

export const useHandleCopyLink = (linkUrl: string) => {
    const [linkCopied, setLinkCopied] = useState(false);

    const { t } = useTranslation();
    const containerRef = useRef(null);

    const copyLink = useCallback(async () => {
        navigator.clipboard.writeText(linkUrl);

        setLinkCopied(true);
    }, [linkUrl]);

    useEffect(() => {
        if (linkCopied) {
            const timer = setTimeout(() => {
                setLinkCopied(false);
            }, 2000);

            return () => clearTimeout(timer);
        }
    }, [linkCopied]);

    const copyLinkButton = useMemo(() => {
        return (
            <Button
                onClick={copyLink}
                variant="outlined"
                sx={{
                    width: 120,
                    height: 34,
                    color: COLOR.black,
                    borderColor: COLOR.black,
                    '&:hover': {
                        backgroundColor: COLOR.white,
                        borderColor: COLOR.black,
                    },
                    '& .MuiButton-startIcon': { marginRight: '4px' },
                }}
                startIcon={<ContentCopyIcon />}
            >
                <Typography sx={{ fontSize: 10, fontWeight: 700 }}>
                    {t('TeamInvitationModal:buttons:copy_link')}
                </Typography>
            </Button>
        );
    }, [copyLink, t]);

    return {
        copyLinkButton,
        linkCopied,
        containerRef,
    };
};
